import { showToast } from '@/components/base/Toast';

const RESOURCE_TYPES = ['角色扮演写真集', 'cos 视频合集', '私拍套图', '场景实拍记录', '拍摄花絮'];

const QUICK_LINKS = [
  { href: '#ranking', label: '本周热度榜' },
  { href: '#albums', label: '精选写真集' },
  { href: '#videos', label: 'cos 视频专区' },
  { href: '#sets', label: '私拍套图' },
  { href: '#updates', label: '更新动态' },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-950 text-background-100">
      <div className="w-full px-4 py-14 md:px-8">
        <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2 md:max-w-md">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-quill-pen-line text-xl" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                善良的女秘书
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              汇聚善良的女秘书角色扮演相关的视觉资源，包含写真集、cos视频与私拍套图，
              满足你对秘书题材的视觉想象，适合收藏与欣赏，资源持续更新。
            </p>
            <div className="mt-6 flex items-center gap-3">
              {['ri-weibo-line', 'ri-bilibili-line', 'ri-mail-line'].map((icon) => (
                <button
                  key={icon}
                  type="button"
                  onClick={() => showToast('静态展示站点，暂不接入跳转')}
                  className="flex h-10 w-10 items-center justify-center rounded-md border border-secondary-800 text-background-300 transition-colors duration-200 hover:border-accent-500 hover:text-accent-400"
                  aria-label="社交入口"
                >
                  <i className={`${icon} text-lg`} />
                </button>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-accent-400">
              快速导航
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {QUICK_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-background-300 transition-colors duration-200 hover:text-background-50"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-accent-400">
              资源类型
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {RESOURCE_TYPES.map((type) => (
                <li key={type} className="text-sm text-background-300">
                  {type}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-12 flex max-w-[1200px] flex-col gap-3 border-t border-secondary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <span>© 2026 善良的女秘书 · 内容均为角色扮演与摄影创作展示</span>
          <span>本站为静态展示页面，所有内容仅供收藏欣赏</span>
        </div>
      </div>
    </footer>
  );
}